import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Layout } from '@/components/Layout';
import { UploadModal } from '@/components/UploadModal';
import { VideoCard, VideoCardSkeleton } from '@/components/VideoCard';
import { useVideoFeed } from '@/hooks/useVideoFeed';

export default function TagPage() {
  const { tag } = useParams<{ tag: string }>();
  const [uploadOpen, setUploadOpen] = useState(false);
  const { data: videos, isLoading } = useVideoFeed(tag);

  const tagLabel = tag ? tag.charAt(0).toUpperCase() + tag.slice(1) : 'Videos';

  useSeoMeta({
    title: `#${tagLabel} – Goblinbox`,
    description: `Watch ${tagLabel} videos on Goblinbox, the decentralized video platform.`,
  });

  return (
    <Layout onUploadClick={() => setUploadOpen(true)}>
      <div className="px-4 sm:px-6 py-6" style={{ maxWidth: 1400, margin: '0 auto' }}>
        <div className="mb-6">
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
            <span style={{ color: 'var(--gb-accent)' }}>#</span>{tagLabel}
          </h1>
          <p className="text-sm mt-1" style={{ color: 'var(--text-secondary)' }}>
            Videos tagged with #{tag} from the Nostr network
          </p>
        </div>

        {isLoading ? (
          <div className="video-grid">
            {Array.from({ length: 8 }).map((_, i) => <VideoCardSkeleton key={i} />)}
          </div>
        ) : videos && videos.length > 0 ? (
          <div className="video-grid">
            {videos.map(event => <VideoCard key={event.id} event={event} />)}
          </div>
        ) : (
          <div className="rounded-xl py-16 px-8 text-center" style={{ border: '2px dashed var(--gb-border)' }}>
            <div className="text-5xl mb-4">🔍</div>
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
              No videos tagged with #{tag} yet. Check back later!
            </p>
          </div>
        )}
      </div>
      <UploadModal open={uploadOpen} onClose={() => setUploadOpen(false)} />
    </Layout>
  );
}
